import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  employerApplicationsKey,
  createEnterpriseApplicationManuallyRoute,
  errorMessage,
  enterpriseApplicationsKey,
  applicationsCountsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useEnterpriseCreateApplicationProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useEnterpriseCreateApplication = ({
  setErrorText = () => { },
}: useEnterpriseCreateApplicationProps) => {
  const client = useQueryClient();

  const { mutate: createApplication, isLoading: isCreateApplicationLoading } =
    useMutation({
      mutationFn: (variables: {
        job_listing_ids: string;
        s_name?: string;
        first_name?: string;
        last_name?: string;
        email: string;
        hired?: boolean;
        resume_doc?: any;
        company_Id: number | string
      }) =>
        axiosInstance
          .post(createEnterpriseApplicationManuallyRoute, variables, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries(enterpriseApplicationsKey);
          client.invalidateQueries(applicationsCountsKey);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    createApplication,
    isCreateApplicationLoading,
  };
};
